import { useState } from 'react'
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Collapse,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface IProps {
  onSend: (message: string) => void
  isLoading?: boolean
  label?: string
  placeholder?: string
}

export const SettingsTgSendCustomMessage = ({
  onSend,
  isLoading = false,
  label = 'Send custom message',
  placeholder = 'Type your message here…',
}: IProps) => {
  const [value, setValue] = useState('')
  const [open, setOpen] = useState(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))

  const handleSend = () => {
    if (!value.trim()) return
    onSend(value.trim())
    setValue('')
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Header with collapse toggle */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? '4px' : '10px' }}>
          <IconButton onClick={() => setOpen((prev) => !prev)}>
            <ExpandMoreIcon
              sx={{
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }}
            />
          </IconButton>
          <Typography variant="subtitle1" fontSize={'14px'}>
            {label}
          </Typography>
        </Box>
      </Box>

      {/* Collapsible content */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            multiline
            minRows={4}
            maxRows={8}
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={isLoading}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              size="small"
              onClick={handleSend}
              disabled={isLoading || !value.trim()}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Collapse>
    </Box>
  )
}
